import { createRequestUrl } from '../../../play-core/utils/request-url-helper';
export const UdpRecommendedMediaApiPath = '/udp-recommended-media';
export const loadUdpRecommendedMedia = async (axios, userId) => {
  const requestUrl = createRequestUrl(`${UdpRecommendedMediaApiPath}/${userId}`);
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};